import { render, staticRenderFns } from "./CreateTargetGroup.vue?vue&type=template&id=6f8f1ba4"
import script from "./CreateTargetGroup.vue?vue&type=script&lang=js"
export * from "./CreateTargetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports